'use client'

import Link from 'next/link'
import { SupportedLocales } from '~/types'

export default function SyllabusButton({
  locale,
  syllabusId,
}: {
  locale: SupportedLocales
  syllabusId?: number | null
}) {
  if (!syllabusId) return null

  return (
    <Link
      href={`/${locale}/syllabus/${syllabusId}`}
      className="inline-flex items-center gap-1 sm:gap-2 rounded-md bg-primary/10 p-2.5 sm:px-4 sm:py-2 text-xs sm:text-sm font-medium text-primary hover:bg-primary/20 transition-colors"
      title="Syllabus"
      aria-label="Open syllabus"
    >
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        fill="none"
        stroke="currentColor"
        strokeWidth="2"
        strokeLinecap="round"
        strokeLinejoin="round"
        className="w-5 h-5 sm:w-4 sm:h-4 flex-shrink-0"
      >
        <rect x="3" y="4" width="18" height="18" rx="2" ry="2" />
        <line x1="16" y1="2" x2="16" y2="6" />
        <line x1="8" y1="2" x2="8" y2="6" />
        <line x1="3" y1="10" x2="21" y2="10" />
      </svg>
      <span className="hidden sm:inline">Syllabus</span>
    </Link>
  )
}
